var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuarioEnviarReporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29485A"
    },
    d: "M42.667,51.182H153.6v17.067H42.667V51.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29485A"
    },
    d: "M42.667,85.316H153.6v17.067H42.667V85.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29485A"
    },
    d: "M42.667,119.449h76.8v17.067h-76.8V119.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29485A"
    },
    d: "M42.667,153.582h76.8v17.067h-76.8V153.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29485A"
    },
    d: "M0,494.916h512v17.067H0V494.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24"
    },
    d: "M34.859,383.982l-1.451-17.067c178.321-15.454,331.059-133.931,390.357-302.814L444.245,5.7 l16.111,5.632l-20.48,58.402C378.377,244.983,219.895,367.948,34.859,383.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24"
    },
    d: "M42.667,418.116H102.4v51.2H42.667V418.116z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB03B"
    },
    d: "M136.533,392.516h59.733v76.8h-59.733V392.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CF26"
    },
    d: "M230.4,349.849h59.733v119.467H230.4V349.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39B54A"
    },
    d: "M324.267,290.116H384v179.2h-59.733V290.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071BC"
    },
    d: "M418.133,170.649h59.733v298.667h-59.733V170.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1C24"
    },
    d: "M486.4,85.316c-3.251,0.017-6.229-1.809-7.68-4.719L448.41,20.01l-60.595,30.319 c-4.215,2.108-9.344,0.393-11.452-3.823c-2.108-4.215-0.393-9.344,3.823-11.452l68.267-34.133c4.215-2.108,9.344-0.401,11.452,3.814 v0.009l34.133,68.267c2.082,4.224,0.341,9.344-3.883,11.426C488.986,85.008,487.706,85.316,486.4,85.316z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarioEnviarReporte);
export default __webpack_public_path__ + "static/media/usuario_enviar_reporte.0a94f8e567e980cd716814d8fc8c73ff.svg";
export { ForwardRef as ReactComponent };